module.exports = __webpack_public_path__ + "img/logo-pedale.6c0a0661.png";